/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const CircleExclamation = props => (
  <svg viewBox="0 0 44 44" fill="none" width="1em" height="1em" {...props}>
    <g clipPath="url(#clip0_6047_20948)">
      <path
        d="M22 44C9.848 44 0 34.152 0 22S9.848 0 22 0s22 9.848 22 22-9.848 22-22 22zm0-41.25C11.37 2.75 2.75 11.37 2.75 22S11.37 41.25 22 41.25 41.25 32.63 41.25 22 32.63 2.75 22 2.75zM22 33a2.058 2.058 0 01-2.063-2.063c0-1.143.92-2.062 2.063-2.062 1.143 0 2.063.92 2.063 2.063C24.063 32.08 23.142 33 22 33zm0-22c1.16 0 2.088.98 2.02 2.14l-.654 11.687a1.376 1.376 0 01-1.375 1.298c-.73 0-1.332-.567-1.375-1.298l-.653-11.687a2.024 2.024 0 012.02-2.14H22z"
      />
    </g>
    <defs>
      <clipPath id="clip0_6047_20948">
        <path fill="#fff" d="M0 0h44v44H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default extendIcon(CircleExclamation);

